import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { supabase } from '../../lib/supabase';
import type { Event } from '../../types';

export default function Events() {
  const [events, setEvents] = useState<Event[]>([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState<'upcoming' | 'past'>('upcoming');

  useEffect(() => {
    const fetchEvents = async () => {
      setLoading(true);
      const now = new Date().toISOString();
      const query = supabase.from('events').select('*').order('start_time');
      if (filter === 'upcoming') query.gte('start_time', now);
      else query.lt('start_time', now);
      const { data } = await query.limit(20);
      setEvents(data || []);
      setLoading(false);
    };
    fetchEvents();
  }, [filter]);

  const formatDate = (dateStr: string) => {
    return new Date(dateStr).toLocaleDateString('es-MX', {
      weekday: 'long', day: 'numeric', month: 'long', hour: '2-digit', minute: '2-digit'
    });
  };

  return (
    <div className="min-h-screen" style={{ backgroundColor: '#1C1C1E' }}>
      <div className="px-4 pt-2 pb-4">
        <h1 className="text-2xl font-bold text-white mb-1">Eventos</h1>
        <p className="text-sm" style={{ color: '#B3B3B3' }}>Castillo del Rey Brisas</p>
      </div>

      <div className="flex px-4 gap-2 mb-4">
        {['upcoming', 'past'].map((f) => (
          <button
            key={f}
            onClick={() => setFilter(f as 'upcoming' | 'past')}
            className="px-5 py-2 rounded-full text-sm font-semibold transition-all"
            style={{
              backgroundColor: filter === f ? '#FFFFFF' : '#2C2C2E',
              color: filter === f ? '#1C1C1E' : '#B3B3B3',
            }}
          >
            {f === 'upcoming' ? 'Próximos' : 'Pasados'}
          </button>
        ))}
      </div>

      <div className="px-4 space-y-4">
        {loading ? (
          [1,2,3].map(i => (
            <div key={i} className="rounded-lg overflow-hidden animate-pulse" style={{ backgroundColor: '#2C2C2E' }}>
              <div className="h-48" style={{ backgroundColor: '#3A3A3C' }} />
              <div className="p-4 space-y-2">
                <div className="h-4 rounded" style={{ backgroundColor: '#3A3A3C', width: '70%' }} />
                <div className="h-3 rounded" style={{ backgroundColor: '#3A3A3C', width: '50%' }} />
              </div>
            </div>
          ))
        ) : events.length === 0 ? (
          <div className="rounded-lg p-10 text-center" style={{ backgroundColor: '#2C2C2E' }}>
            <p className="text-4xl mb-3">📅</p>
            <p style={{ color: '#B3B3B3' }}>No hay eventos {filter === 'upcoming' ? 'próximos' : 'pasados'}</p>
          </div>
        ) : (
          events.map((event) => (
            <Link
              key={event.id}
              to={`/events/${event.id}`}
              className="block rounded-lg overflow-hidden"
              style={{ backgroundColor: '#2C2C2E' }}
            >
              {event.image_url && (
                <img
                  src={event.image_url}
                  alt={event.title}
                  className="w-full h-52 object-cover"
                  onError={(e) => { (e.target as HTMLImageElement).style.display = 'none'; }}
                />
              )}
              <div className="p-4">
                <h3 className="font-bold text-white text-base leading-tight">{event.title}</h3>
                <p className="text-sm mt-1.5 capitalize" style={{ color: '#4A90D9' }}>
                  📅 {formatDate(event.start_time)}
                </p>
                {event.location && (
                  <p className="text-sm mt-0.5" style={{ color: '#B3B3B3' }}>📍 {event.location}</p>
                )}
                {event.description && (
                  <p className="text-sm mt-2 line-clamp-2" style={{ color: '#8E8E93' }}>{event.description}</p>
                )}
              </div>
            </Link>
          ))
        )}
      </div>
    </div>
  );
}
